// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import Profile from './Profile';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(Profile);
